"use client";
import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { BhipLogo, Logo, mailIcon } from "@/assets/images";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaMapMarkerAlt,
  FaPaperPlane,
} from "react-icons/fa";
import { _setTimeOut, MiniLoader, storeAssigned } from "@/services/Methods/normalMethods";
import { getAllCustomerData, SignUpFormApi } from "@/services/Redux/Reducer/LoginSlice";
import { useDispatch } from "react-redux";

const Footer = () => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [processLoader, setProcessLoader] = useState(false);
  const dispatch = useDispatch();

  function _emailValidate(email, callback = null) {

    dispatch(getAllCustomerData((userDatas) => {
      if (userDatas?.length > 0) {
        setEmailError("E-mail is already exist");
        setProcessLoader(false);
        setTimeout(() => setEmailError(''), 5000);
      } else {
        callback()
      }
    }, null, email));
  }

  function _handleSubmit(values) {
    try {
      // birthDate: moment(startDate).utc().format() 
      setProcessLoader(true);
      _emailValidate(email, () => {
        dispatch(SignUpFormApi({ email: email }, 'leadUser', (data) => {
          setEmailError('')
          setProcessLoader(false);
          setSuccessMsg('Thank you for joining our list.');
          _setTimeOut(() => setSuccessMsg(''), 4000);
        }));
      })
    } catch (error) {
      setProcessLoader(false);
      console.log(error, 'ddddddddddddddddddddddddddddddddd')
    }
  }
  return (
    <footer className="bg-[#f0f0f0] text-black p-[70px_0_62px]">
      <div className="container mx-auto px-[15px] max-w-[1780px] w-full lg_container">
        {/* Top Section */}
        <div className="flex top-row">
          {/* Logo and Meaning */}
          <div className="max-w-[490px] w-full flex flex-col fist-col">
            <div className="2xl:-mt-[45px] ">
              <Image src={Logo} alt="bHIP Logo" width={100} className="2xl:max-w-[207px] xl:max-w-[170px] max-w-[150px] w-full" />
              <div className="mt-4 text-sm leading-6">
                <p className="xl:text-[18px] text-[15px] leading-[35px] text-[#919191]">bHIP means</p>
                <p className="xl:text-[18px] text-[15px] leading-[35px] text-[#919191]">H = Helping</p>
                <p className="xl:text-[18px] text-[15px] leading-[35px] text-[#919191]">I = Impact</p>
                <p className="xl:text-[18px] text-[15px] leading-[35px] text-[#919191]">P = People</p>
              </div>
            </div>
            {/* Social Icons */}
            <div className="flex mt-auto gap-[7px] soci">
              <FaFacebookF className="xl:w-[50px] w-[40px] xl:h-[50px] h-[40px] bg-[#003a63] text-white rounded-full p-3 cursor-pointer" />
              <FaYoutube className="xl:w-[50px] w-[40px] xl:h-[50px] h-[40px] bg-[#003a63] text-white rounded-full p-3 cursor-pointer" />
              <FaInstagram className="xl:w-[50px] w-[40px] xl:h-[50px] h-[40px] bg-[#003a63] text-white rounded-full p-3 cursor-pointer" />
            </div>
          </div>

          {/* Quick Links */}
          <div className="max-w-[270px] w-full col_2">
            <h4 className="font-medium xl:text-[20px] text-[17px] xl:mb-[30px] mb-[15px] text-black leading-[1] uppercase">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li className="xl:text-[18px] text-[15px] leading-[35px] text-[#919191]">
                <Link className="!no-underline inline-block" href={`/${storeAssigned()}/products`}>Products</Link>
              </li>
              <li className="xl:text-[18px] text-[15px] leading-[35px] text-[#919191]">
                <Link className="!no-underline inline-block" href={`/${storeAssigned()}/lifestyle`}>Lifestyle</Link>
              </li>
              <li className="xl:text-[18px] text-[15px] leading-[35px] text-[#919191]">
                <Link className="!no-underline inline-block" href={`/${storeAssigned()}/aboutus`}>About</Link>
              </li>
              <li className="xl:text-[18px] text-[15px] leading-[35px] text-[#919191]">
                <Link className="!no-underline inline-block" href={`/${storeAssigned()}/signin`}>Login</Link>
              </li>
              <li className="xl:text-[18px] text-[15px] leading-[35px] text-[#919191]">
                <Link className="!no-underline inline-block" href={`/${storeAssigned()}/distributor`}>Join</Link>
              </li>
            </ul>
          </div>

          {/* Disclosures */}
          <div className="max-w-[360px] w-full col_3">
            <h4 className="font-medium xl:text-[20px] text-[17px] xl:mb-[30px] mb-[15px] text-black leading-[1] uppercase">Disclosures</h4>
            <ul className="space-y-2 text-sm">
              <li className="xl:text-[18px] text-[15px] leading-[35px] text-[#919191]"> <a className="!no-underline inline-block" href="#">Refund Policy</a> </li>
              <li className="xl:text-[18px] text-[15px] leading-[35px] text-[#919191]"> <a className="!no-underline inline-block" href="#">Terms & Conditions</a></li>
              <li className="xl:text-[18px] text-[15px] leading-[35px] text-[#919191]"> <a className="!no-underline inline-block" href="#">Privacy Policy</a></li>
              <li className="xl:text-[18px] text-[15px] leading-[35px] text-[#919191]"> <a className="!no-underline inline-block" href="#">Shipping Policy</a></li>
              <li className="xl:text-[18px] text-[15px] leading-[35px] text-[#919191]"> <a className="!no-underline inline-block" href="#">Policies & Procedures</a></li>
            </ul>
          </div>

          {/* Address */}
          <div className="max-w-[390px] w-full address">
            <h4 className="font-medium xl:text-[20px] text-[17px] xl:mb-[30px] mb-[15px] text-black leading-[1] uppercase">Address</h4>
            <p className="flex items-start xl:gap-[22px] gap-[12px]">
              <FaMapMarkerAlt className="mt-1 w-[26px] h-[26px]" />
              <span className="xl:text-[18px] text-[15px] leading-[23px] text-[#919191]">
                b:hip Global <br />
                901 Sam Rayburn Highway <br />
                Melissa, TX, 75454
              </span>
            </p>

            <p className="flex items-start xl:gap-[22px] gap-[12px] m-[28px_0_52px]">
              <Image src={mailIcon} alt="Mail icon" width={100} className="max-w-[28px] w-full" />

              <a href="mailto:support@bhip.com" className="underline xl:text-[18px] text-[15px] leading-[23px] text-[#919191]">support@bhip.com</a>

            </p>


            <h4 className="font-medium xl:text-[20px] text-[17px] xl:mb-[30px] mb-[15px] text-black leading-[1] uppercase">Subscribe</h4>
            <div className="flex items-center border rounded-full overflow-hidden">
              <input
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email here"
                className="w-full  xl:text-[18px] text-[15px] text-[#919191] bg-white outline-none xl:min-h-[50px] min-h-[40px] p-[10px_10px_10px_30px]"
              />
              <button className="bg-white text-black  xl:min-h-[50px] min-h-[40px] xl:p-[10px_30px_10px_10px] p-[10px_15px_10px_10px]">
                {processLoader ? <MiniLoader /> : <FaPaperPlane className="xl:w-[20px] w-[15px] xl:h-[20px] h-[15px]" onClick={() => _handleSubmit()} />}
              </button>
            </div>
            {emailError && <p className="text-[12px] text-red-800 mt-1">{emailError}</p>}
            {successMsg && <p className="text-sm text-green-800">{successMsg}</p>}
            <div className="mt-[50px] flex gap-3">
              <img src="/images/master_card.png" alt="MasterCard" className="h-[30px] object-contain" />
              <img src="/images/visa-card.png" alt="Visa" className="h-[30px] object-contain" />
            </div>
          </div>

        </div>

        {/* Disclaimer */}
        <div className="mt-[45px] border-t-[4px] border-[#e7e7e7] pt-[20px]">
          <p className="xl:text-[20px] text-[17px] text-[#919191] leading-[35px] text-center max-w-[1468px] mx-auto">
            This product is not for use by or sale to persons under the age of
            18. This product should be used only as directed on the label. It
            should not be used if you are pregnant or nursing. Consult with a
            physician before use if you have a serious medical condition or use
            prescription medications. A Doctor’s advice should be sought before
            using this and any supplemental dietary product. All trademarks and
            copyrights are property of their respective owners.
          </p>
        </div>

        {/* FDA Box */}
        <div className="mt-4 border-2 border-black text-xs text-center p-3 max-w-[1023px] mx-auto text-[#222222] xl:!text-[20px] !text-[17px] leading-[1.3] min-h-[99px] flex items-center justify-center">
          These statements have not been evaluated by the FDA. This product is
          not intended to diagnose, treat, cure or prevent any disease.
          Individual results will vary.
        </div>
      </div>
    </footer>
  );
};

export default Footer;

// "use client";
// import React from "react";
// import Image from "next/image";
// import _ from "lodash";
// import { Logo } from "@/assets/images";
// import localStorageCall from "@/services/Methods/localstorage.hook";

// export const Footer = () => {
//   const REFFERAL_VALUES = localStorageCall().getItem('refferal_link');
//   return (
//     <footer className="footer lg:p-[50px_0_90px] p-[50px_0_50px] bg-[##f2f2f2]">
//       <div className="container mx-auto xl:max-w-[1210px] px-[15px]">
//         <div className="logo">
//           <Image src={Logo} alt="Viago-logo" className="md:!w-[148px] !w-[120px]" />
//         </div>
//         <div className="row flex flex-wrap justify-between items-start pt-7">

//           <div className="col-footer w-auto">
//             <div className="max-w-[max-content] text-[15px] text-black text-start">

//               <h3 className="font-semibold mb-3 text-[25px]">
//                 Contact
//               </h3>
//               <p className="text-[15px font-medium">
//                 {REFFERAL_VALUES?.name}
//               </p>
//               <p className="text-[15px] mb-3">
//                 {REFFERAL_VALUES?.type}
//               </p>
//               <p className="text-[15px] text-black mb-3 cursor-pointer">
//                 support@bhipglobal.com
//               </p>
//               <p className="text-[15px] text-black mb-3 cursor-pointer">
//                 Privacy Policy<br />                Terms & condition
//               </p>
//               <p className="text-[15px] text-black">
//                 Copyright ©2025. All rights reserved
//               </p>
//             </div>
//           </div>

//           <div className="text-black col-footer lg:max-w-[600px] max-w-[100%] w-full">
//             <p className="text-[15px] text-black text-start">
//               This product is not for use by or sale to persons under the age of 18. This product should be used only as directed on the label. It should not be used if you are pregnant or nursing. Consult with a physician before use if you have a serious medical condition or use prescription medications. A Doctor's advice should be sought before using this and any supplemental dietary product. All trademarks and copyrights are property of their respective owners. These statements have not been evaluated by the FDA. This product is not intended to diagnose, treat, cure or prevent any disease. Individual results will vary. By using this site, you agree to follow the Privacy Policy and all Terms & Conditions printed on this site. Void Where Prohibited by Law.
//             </p>
//           </div>
//         </div>
//       </div>
//     </footer >
//   );
// };
// export default Footer;